import i18n from "@/i18n";

const EVENT_NAME = "log_out";

function logoutEvent() {
  window.gtag?.("event", EVENT_NAME, {
    site_language: i18n.language.toUpperCase(),
  });

  window.rdt?.("track", "Custom", { customEventName: EVENT_NAME });
}

export default logoutEvent;
